import React, { useEffect, useRef, useState } from "react";
import { apiResponse } from "../../../../utils/apiResponse";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import DatePicker from "react-datepicker";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { Button, Col, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import WidgetNote from "../../WidgetNote";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";

const BestWesternRoomMaintaince = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const tableData = [
    {
      id: 1,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 2,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 3,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 4,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 5,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 6,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 7,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 8,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 9,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
    {
      id: 10,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      PrintedValue: "-",
      PrintedCaption: "0",
      BusinessDateVal: "-",
      BusinessDateCaption: "0",
      HotelName: "0",
      textBox25: "0",
      textBox26: "0",
      textBox1: "0",
      textBox2: "0",
      textBox3: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "-",
      textBox11: "0",
      textBox12: "-",
      textBox7: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
    },
  ];

  const [roomMaintaince, setRoomMaintaince] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startRangeDate, setStartRangeDate] = useState();
  const [endRangeDate, setEndRangeDate] = useState();
  const startRangeDateRef = useRef();
  const endRangeDateRef = useRef();
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };
  const handleDateChange = (event) => {
    const [start, end] = event;
    let startSelectedDate = "",
      endSelectedDate = "";
    if (start) {
      let date = new Date(start);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      startRangeDateRef.current = startSelectedDate;
    }
    if (end) {
      let date = new Date(end);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      endRangeDateRef.current = endSelectedDate;
    }

    setStartRangeDate(event[0]);
    setEndRangeDate(event[1]);
    if (event[0] !== null && event[1] !== null) {
      // getRoomMaintaince();
    }
  };

  const getRoomMaintaince = async () => {
    setLoading(true);
    let payload = {
      AsOfDate: para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    if (startRangeDateRef.current && endRangeDateRef.current) {
      payload = {
        ...payload,
        startDate: startRangeDateRef.current,
        endDate: endRangeDateRef.current,
      };
    }
    let reservationForecastResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.WIDGET_MODULE.BEST_WESTERN_ROOM_MAINTAINCE,
        body: payload,
      },
      false
    );

    let response = apiResponse(false, reservationForecastResponse);

    if (response?.isValidate) {
      setLoading(false);
      setRoomMaintaince(response?.data?.data);
    }

    if (!response?.isValidate) {
      setLoading(false);
      setRoomMaintaince(null);
    }
  };

  useEffect(() => {
    if (api === 0) {
      setRoomMaintaince(tableData);
    } else {
      if (para?.asOfDate) {
        getRoomMaintaince();
      }
    }
  }, [para?.asOfDate]);

  const [tblids, settblids] = useState({
    tblBestWesternRoomMaintaince: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "menuicon", propertyCode)}
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.tblBestWesternRoomMaintaince,
                  "Best Western Room Maintaince",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.widgetBestWesternRoomMaintaince,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "downloadIcon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.tblBestWesternRoomMaintaince}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.tblBestWesternRoomMaintaince,
                  // "Best Western Room Maintaince"
                  `${para?.propertyCode}-Best Western Room Maintaince-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
          <Table
            responsive
            id={tblids.tblBestWesternRoomMaintaince}
            className="positionStaticTable"
          >
            <thead>
              <tr>
                <th id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "date-picker", propertyCode)}
                  className="width175"
                  onClick={() => {
                    setOpenDatePicker(true);
                  }}
                >
                  Date{" "}
                                  <DatePicker id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "date-picker", propertyCode)}
                                      portalId="datepicker-root"
                    onChange={(event) => handleDateChange(event)}
                    startDate={startRangeDate}
                    endDate={endRangeDate}
                    selectsRange
                    monthsShown={2}
                    open={openDatePicker}
                    shouldCloseOnSelect={false}
                  >
                    <div className="w-100" style={{ display: "inline-block" }}>
                      <div className="content-inside-calendar">
                        <p>
                          {startRangeDate
                            ? commonService.getDateInFormat(startRangeDate)
                            : ""}
                          {startRangeDate && endRangeDate ? " - " : ""}
                          {endRangeDate
                            ? commonService.getDateInFormat(endRangeDate)
                            : ""}
                        </p>
                        <div className="d-flex align-items-center gap-2">
                          <button id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "date-Cancel-btn", propertyCode)}
                            className="secondary-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setStartRangeDate("");
                              setEndRangeDate("");
                              setOpenDatePicker(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button id={commonService.generateGlobalClickTrackerID("BestWesternRoomMaintaince", "date-Apply-btn", propertyCode)}
                            disabled={
                              startRangeDate && endRangeDate ? false : true
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                startRangeDateRef.current &&
                                endRangeDateRef.current
                              ) {
                                getRoomMaintaince();
                              }

                              setOpenDatePicker(false);
                            }}
                            className="primary-btn"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </DatePicker>
                  {startRangeDate && endRangeDate && (
                    <span
                      style={{ display: "none" }}
                    >{`${commonService.getDateInFormat(
                      startRangeDate
                    )} - ${commonService.getDateInFormat(endRangeDate)}`}</span>
                  )}
                </th>
                <th colSpan={21}></th>
              </tr>
              <tr>
                <th className="width100">asOfDate</th>
                {/* <th className="width100">propertyCode</th>
                <th className="width100">pullDateId</th> */}
                <th className="width100 text-center">PrintedValue</th>
                <th className="width100 text-center">PrintedCaption</th>
                <th className="width100 text-center">BusinessDateVal</th>
                <th className="width100 text-center">BusinessDateCaption</th>
                <th className="width100 text-center">HotelName</th>
                <th className="width100 text-center">textBox25</th>
                <th className="width100 text-center">textBox26</th>
                <th className="width100 text-center">textBox1</th>
                <th className="width100 text-center">textBox2</th>
                <th className="width100 text-center">textBox3</th>
                <th className="width100 text-center">textBox4</th>
                <th className="width100 text-center">textBox5</th>
                <th className="width100 text-start">textBox6</th>
                <th className="width100 text-center">textBox11</th>
                <th className="width100 text-start">textBox12</th>
                <th className="width100 text-center">textBox7</th>
                <th className="width100 text-center">textBox8</th>
                <th className="width100 text-center">textBox9</th>
                <th className="width100 text-center">textBox10</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : roomMaintaince && roomMaintaince?.length > 0 ? (
                roomMaintaince?.map((item) => (
                  <tr key={item?.id} className="shadowOnHover">
                    <td>
                      {item?.asOfDate
                        ? commonService.getDateInFormat(item?.asOfDate)
                        : ""}
                    </td>
                    {/* <td>{item?.propertyCode}</td>
                    <td>{item?.pullDateId}</td> */}
                    <td className="text-center">
                      {item?.PrintedValue
                        ? commonService.getDateInFormat(item?.PrintedValue)
                        : ""}
                    </td>
                    <td className="text-center">{item?.PrintedCaption}</td>
                    <td className="text-center">
                      {item?.BusinessDateVal
                        ? commonService.getDateInFormat(item?.BusinessDateVal)
                        : ""}
                    </td>
                    <td className="text-center">{item?.BusinessDateCaption}</td>
                    <td className="text-center">{item?.HotelName}</td>
                    <td className="text-center">{item?.textBox25}</td>
                    <td className="text-center">{item?.textBox26}</td>
                    <td className="text-center">{item?.textBox1}</td>
                    <td className="text-center">{item?.textBox2}</td>
                    <td className="text-center">{item?.textBox3}</td>
                    <td className="text-center">{item?.textBox4}</td>
                    <td className="text-center">{item?.textBox5}</td>
                    <td className="text-start">
                      {item?.textBox6
                        ? commonService.getDateInFormat(item?.textBox6)
                        : ""}
                    </td>
                    <td className="text-center">{item?.textBox11}</td>
                    <td className="text-start">
                      {item?.textBox12
                        ? commonService.getDateInFormat(item?.textBox12)
                        : ""}
                    </td>
                    <td className="text-center">{item?.textBox7}</td>
                    <td className="text-center">{item?.textBox8}</td>
                    <td className="text-center">{item?.textBox9}</td>
                    <td className="text-center">{item?.textBox10}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={22}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default BestWesternRoomMaintaince;
